// src/services/settingServices.js
import api from "../api/axios";

export async function getSetting() {
  const response = await api.get("/api/v1/setting");
  return response.data;
}

export async function updateSetting(settingData) {
  const response = await api.put("/api/v1/setting", settingData);
  return response.data;
}
